// Utilities to help make vite-land classes (so far always Svelte components)
// accessible to sprockets-land scripts and rails svelte_component helper.

const componentClasses = new Map();

const objectPrototype = Object.getPrototypeOf({})

/*
 * obj is a POJO with studly-caps string keys and values that are either a
 * component class or another POJO. N.b., POJO-detection technique here is not
 * robust to all possible values but should be good enough for this use.
 */
function registerComponent(obj, prefix = "") {
  for (const [key, value] of Object.entries(obj)) {
    if (objectPrototype === Object.getPrototypeOf(value)) {
      registerComponent(value, `${prefix}${key}/`);
    } else {
      componentClasses.set(`${prefix}${key}`, value);
    }
  }
}

function getComponent(key) {
  return componentClasses.get(key);
}

function listComponents() {
  return componentClasses.keys()
}

export {registerComponent, getComponent, listComponents}